import type { Discount } from '@types';
import './style.scss';

type ProductDiscountProps = {
  discount: Discount;
};

const ProductDiscount = ({ discount }: ProductDiscountProps) => (
  <div className="product-discount">
    <div>{discount.discount}</div>
    <div>{discount.title}</div>
  </div>
);

export { ProductDiscount };
